import { useContext } from 'react';
import axios from 'axios';
import environment from './environment';

const env = environment;

const useToken = async () => {
  const t = await localStorage.getItem('accessToken');
  return t != null ? t : '';
};

const Api = axios.create({
  baseURL: env.yapps.api.url,
  headers: {
    'Content-Type': 'application/json',
  },
});

Api.interceptors.request.use(async (req) => {
  const t = await useToken();
  if (t) {
    req.headers.Authorization = `Bearer ${t}`;
  }
  return req;
});

Api.interceptors.response.use(
  (response) => response,
  async (error) => {
    return Promise.reject(error);
  },
);

export default Api;
